import { render, staticRenderFns } from "./Loading.vue?vue&type=template&id=1738ef81&scoped=true&"
import script from "./Loading.vue?vue&type=script&lang=ts&"
export * from "./Loading.vue?vue&type=script&lang=ts&"
import style0 from "./loading.scss?vue&type=style&index=0&id=1738ef81&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1738ef81",
  null
  
)

export default component.exports